import { provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

window.addEventListener('unhandledrejection', (event) => {
  const msg: string =
    typeof event.reason === 'string'
      ? event.reason
      : typeof event.reason?.message === 'string'
      ? event.reason.message
      : String(event.reason ?? '');

  const isChunkError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Failed to load module script');

  if (!isChunkError) return;
  if (!navigator.onLine) {
    console.warn('[ChunkReload] offline, skipping reload');
    return;
  }
  event.preventDefault();

  const RELOAD_KEY = 'chunk_reload_timestamp';
  const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
  if (Date.now() - lastReload < 10_000) {
    console.warn('[ChunkReload] throttled, skipping reload');
    return;
  }

  console.warn('[ChunkReload] chunk error caught, reloading...', msg);
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
